/**
 * endSentence, guards a sentence that ends on an interpolated name
 * (person, organization, client, unit or county) from doubling a
 * terminal mark when the name itself already ends in one (a title,
 * abbreviation, or punctuation, "I. Richard Ploss, Esq.", "Foo Inc.").
 *
 * Trims trailing whitespace, then appends a period unless the trimmed
 * string already ends in `.`, `!`, `?` or `…`. A closing quote or
 * bracket AFTER the mark is the new last character, so the regex does
 * not see the mark and a period is appended anyway, documented
 * behavior, not a bug this helper tries to fix (contract addendum
 * revision 4 §5 item 4).
 */
export function endSentence(text: string): string {
  const t = text.trimEnd();
  return /[.!?…]$/.test(t) ? t : t + '.';
}
